<template>
  <v-container>
    <v-card v-if="$route.query.token == null" max-width="400">
      <v-card-title>Wachtwoord herstellen</v-card-title>
      <v-card-text>
        <v-form ref="formRequest" onsubmit="return false;">
          <v-text-field
            label="E-mailadres"
            maxlength="250"
            autofocus
            v-model="email"
            type="email"
          >
          </v-text-field>

          <v-btn type="submit" @click="requestReset()" color="primary"
            >Herstel wachtwoord</v-btn
          >
          <v-alert
            v-show="message"
            type="info"
            class="mt-4"
            border="top"
            text
            >{{ message }}</v-alert
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-card v-if="$route.query.token" max-width="400">
      <v-card-title>Wachtwoord herstellen</v-card-title>
      <v-card-text>
        <v-form ref="formReset" onsubmit="return false;">
          <v-text-field
            label="Gebruikersnaam"
            readonly
            filled
            v-model="$route.query.loginname"
          ></v-text-field>
          <v-text-field
            label="Nieuw wachtwoord"
            v-model="newpw"
            type="password"
            maxlength="100"
            autofocus
          ></v-text-field>
          <v-text-field
            label="Herhaal wachtwoord"
            v-model="newpwr"
            type="password"
            maxlength="100"
            autofocus
          ></v-text-field>
          <v-btn type="submit" @click="reset()"> Wachtwoord instellen </v-btn>
          <v-alert
            v-show="message"
            type="info"
            class="mt-4"
            border="top"
            text
            >{{ message }}</v-alert
          >
          <v-alert
            v-show="errormessage"
            type="error"
            class="mt-4"
            border="top"
            text
            >{{ errormessage }}</v-alert
          >
          <v-alert v-show="success" type="info" class="mt-4" border="top" text>
            Het wachtwoord is aangepast. Klik
            <router-link to="/start">hier</router-link> om in te loggen.
          </v-alert>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      email: "",
      errormessage: "",
      message: "",
      newpw: "",
      newpwr: "",
      success: false,
    };
  },
  methods: {
    loaddata: function () {},
    requestReset: function () {
      this.$api
        .RequestPasswordReset({ Email: this.email })
        .then((response) => {
          if (response.data == "Ok") {
            this.message =
              "Er is een mail naar " +
              this.email +
              " verstuurd voor het herstellen van het wachtwoord.";
            this.errormessage = "";
          } else {
            this.errormessage = response.data;
            this.message = "";
          }
        })
        .catch(() => {
          this.errormessage = "Herstel wachtwoord mislukt.";
          this.message = "";
        });
    },
    reset: function () {
      if (this.newpw == this.newpwr) {
        this.$api
          .PasswordReset({
            Token: this.$route.query.token,
            NewPassword: this.newpw,
          })
          .then((response) => {
            if (response.data == "Ok") {
              this.success = true;
              this.message = "";
              this.errormessage = "";
            } else {
              this.success = false;
              this.errormessage = response.data;
              this.message = "";
            }
          })
          .catch((e) => {
            this.success = false;
            this.errormessage = "Herstel wachtwoord mislukt." + e;
            this.message = "";
          });
      } else {
        this.success = false;
        this.errormessage =
          "Wachtwoord en herhaald wachtwoord zijn niet gelijk.";
        this.message = "";
      }
    },
  },
  created: function () {
    this.loaddata();
  },
};
</script>


<style scoped>
</style>
